import React from 'react';
import {useFormik} from "formik";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";

const PasswordTextField = (props) => {
    return (
        <TextField
            type={'password'}
            variant={'outlined'}
            size={'small'}
            fullWidth
            {...props}/>
    );
}

const ChangePasswordDialog = (props) => {
    const {open, onClose, submitCallback} = props

    const onSubmit = async (values) => {
        await submitCallback(values, handleCloseDialog)
    }

    const {getFieldProps, resetForm, submitForm} = useFormik({
        initialValues: {
            old_password: '',
            password: '',
            password2: ''
        },
        onSubmit: onSubmit
    })

    const handleCloseDialog = () => {
        onClose()
        resetForm()
    }

    return (
        <Dialog open={open} onClose={handleCloseDialog} maxWidth={"xs"} fullWidth>
            <DialogTitle>Сменить пароль</DialogTitle>
            <DialogContent>
                <Grid container spacing={2} direction={'column'}>
                    <Grid item>
                        <PasswordTextField label={'Текущий пароль'} {...getFieldProps('old_password')}/>
                    </Grid>
                    <Grid item>
                        <PasswordTextField label={'Новый пароль'} {...getFieldProps('password')}/>
                    </Grid>
                    <Grid item>
                        <PasswordTextField label={'Повторите пароль'} {...getFieldProps('password2')}/>
                    </Grid>
                    <Grid item>
                        <Typography align={'center'} color={'error'}>
                            После смены пароля будет необходимо произвести повторный вход в систему
                        </Typography>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialog}>
                    Отмена
                </Button>
                <Button onClick={submitForm}>
                    Сохранить
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ChangePasswordDialog;